const files = require.context('./routers', false, /\.js$/)

let configRouters = []

files.keys().forEach(key => {
  configRouters = configRouters.concat(files(key).default)
})

export default configRouters
